<template>
  <transition name="fade" appear>
    <div id="home">
      <!-- 轮播图 -->
      <section class="swiper">
        <el-carousel height="605px">
          <el-carousel-item
            class="pointer"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <!-- <div v-if="item.pathType==1">
            <a  :href="[item.pathUrl]">
              <el-image
                :src="item.url"
                style="height: 100%; width: 100%"
                fit="fill"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </a>
          </div>     -->
            <el-image
              :src="item.url"
              style="height: 100%; width: 100%"
              fit="fill"
              @click="toBannerContent(item)"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </el-carousel-item>
        </el-carousel>
      </section>
      <!-- 儿童天地 -->

      <div
        style="
          display: flex;
          height: 120px;
          justify-content: center;
          align-items: center;
        "
        @click="goPlaygroundSon('0')"
      >
        <div class="titlebg">
          <div
            style="
              font-size: 24px;
              color: white;
              margin-top: 10px;
              margin-left: 10px;
            "
          >
            儿童乐园
          </div>
        </div>
      </div>

      <section class="navBox">
        <template v-for="(item, index) in playgroundIcon">
          <div class="nav_item" :key="index" @click="goPlaygroundSon(index)">
            <div class="navItem_img hoverBox1">
              <el-image
                :src="item.imageUrl"
                fit="fill"
                style="height: 100%; width: 100%"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div class="navItem_text hoverText">
              {{ item.playgroundTypeName }}
            </div>
          </div>
        </template>
      </section>
      <!-- 布朗FM -->
      <!-- <h1 class="topTitle">布朗FM</h1>
      <div class="homeTitle">
        <el-row :gutter="20" align="middle" type="flex">
          <el-col :span="12" class="title">布朗FM</el-col>
          <el-col :span="12" style="text-align: right"
            ><el-button type="text" style="color: #fff" @click="goFm()"
              >更多>></el-button
            ></el-col
          >
        </el-row>
      </div> -->

      <div
        style="
          display: flex;
          height: 120px;
          justify-content: center;
          align-items: center;
        "
        @click="goFm()"
      >
        <div class="titlebg">
          <div
            style="
              font-size: 24px;
              color: white;
              margin-top: 10px;
              margin-left: 10px;
            "
          >
            布朗FM
          </div>
        </div>
      </div>
      <section class="navBox">
        <template v-for="(item, index) in fmIcon">
          <div class="nav_item" :key="index" @click="goFmSon(index)">
            <div class="navItem_img hoverBox1">
              <el-image
                :src="item.imageUrl"
                fit="fill"
                style="height: 100%; width: 100%"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div class="navItem_text hoverText">
              {{ item.audioTypeName }}
            </div>
          </div>
        </template>
      </section>
      <!-- CEC考试 -->
      <!-- <h1 class="topTitle">CEC活动</h1> -->
      <div
        style="
          display: flex;
          height: 120px;
          justify-content: center;
          align-items: center;
        "
      >
        <div class="titlebg">
          <div
            style="
              font-size: 24px;
              color: white;
              margin-top: 10px;
              margin-left: 10px;
            "
          >
            CEC考试
          </div>
        </div>
      </div>
      <section class="navBox">
        <template v-for="(item, index) in testIcon">
          <div class="nav_item" :key="index" @click="goCec(index)">
            <div class="navItem_img hoverBox1">
              <el-image
                :src="item.img"
                fit="fill"
                style="height: 100%; width: 100%"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div class="navItem_text hoverText">{{ item.text }}</div>
          </div>
        </template>
      </section>

      <!-- 主题教学大纲 -->
      <!-- <h1 class="topTitle">教师园地</h1> -->
      <div class="centerTitle" @click="goPublicIcon()">
        <p>主题教学大纲</p>
        <!-- <el-row :gutter="20" align="middle" type="flex">
          <el-col :span="12" class="title">主题教学大纲</el-col>
          <el-col :span="12" style="text-align: right"
            ><el-button
              type="text"
              fit="fill"
              style="color: #fff"
              @click="goPublicIcon()"
              >更多>></el-button
            ></el-col
          >
        </el-row> -->
      </div>
      <section class="navBox mb46">
        <template v-for="(item, index) in publicIcon">
          <div class="nav_item" :key="index" @click="goPublicIconSon(index)">
            <div class="navItem_img hoverBox1">
              <el-image
                :src="item.imageUrl"
                fit="fill"
                style="height: 100%; width: 100%"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div class="navItem_text hoverText">
              {{ item.syllabusTypeName }}
            </div>
          </div>
        </template>
      </section>
      <!-- 节日活动 -->
      <!-- <h1 class="topTitle">电子银行</h1> -->
      <div class="centerTitle" @click="goHoliday(index)">
        <p>节日活动</p>
        <!-- <div class="homeTitle">
        <el-row :gutter="20" align="middle" type="flex">
          <el-col :span="12" class="title">节日活动</el-col>
          <el-col :span="12" style="text-align: right"
            ><el-button
              type="text"
              style="color: #fff"
              @click="goHoliday(index)"
              >更多>></el-button
            ></el-col
          >
        </el-row>
      </div> -->
      </div>
      <section class="navBox" style="margin-bottom: 50px">
        <template v-for="(item, index) in activityList">
          <div
            class="nav_item_festival"
            :key="index"
            @click="goHolidayDetail(index)"
          >
            <div class="navItem_img_festival hoverBox1">
              <el-image
                :src="item.imageUrl"
                fit="fill"
                style="height: 100%; width: 100%; border-radius: 3pt"
              >
              </el-image>
            </div>

            <div class="navItem_text__festival hoverText">
              {{ item.activityName }}
            </div>
            <div
              class="navItem_text__festival hoverText"
              style="font-size: 8px; margin-left: 3%"
            >
              活动时间:{{
                item.activityStartTime | dataFormat
              }}--<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                item.activityEndTime | dataFormat
              }}
            </div>
          </div>
        </template>
      </section>
    </div>
  </transition>
</template>

<script>
import { CHANGE_NAVINDEX } from "../../store/mutation-types";
export default {
  name: "Home",
  data() {
    return {
      url: "http://www.catticenter.com/cectest",
      //轮播图
      swiperList: [],
      // 主题大纲
      publicIcon: [],
      // 节日活动
      activityList: [],
      //cec考试
      testIcon: [
        { img: require("../../assets/img/home/cec1.png"), text: "CEC介绍" },
        { img: require("../../assets/img/home/cec2.png"), text: "报名方式" },
        { img: require("../../assets/img/home/cec3.png"), text: "考点查询" },
        { img: require("../../assets/img/home/cec4.png"), text: "CEC新闻" },
        { img: require("../../assets/img/home/cec5.png"), text: "活动集锦" },
      ],
      //fm
      fmIcon: [],
      playgroundIcon: [],
      //个人信息
      userInfo: {},
    };
  },
  methods: {
    //轮播图前往富文本
    toBannerContent(item) {
      console.log("进入方法BannerContent", item);
      var arr = item.pathUrl.split("&");
      console.log("arr", arr);

      if (item.pathType == 1) {
        window.location.href = arr[0];
      } else if (item.pathType == 2) {
        this.$router.push({
          path: "/BannerContent",
          query: {
            content: item.content,
          },
        });
      }else{
      }
    },

    //获取fm
    getAudioTypeUrl() {
      var that = this;
      var getData = {};
      var condition = {};
      let a = sessionStorage.getItem("userInfo");
      if (a == null) {
        condition.promptCode = "rz";
      } else {
        let promptCode = JSON.parse(
          sessionStorage.getItem("userInfo")
        ).promptCode;
        if (promptCode == "kj" || promptCode == "KJ") {
          condition.promptCode = "kj";
        } else if (promptCode == "rz" || promptCode == "RZ") {
          condition.promptCode = "rz";
        } else {
          return;
        }
      }
      getData.condition = condition;
      getData.pageSize = 5;
      getData.currPage = 1;
      this.$api.home.getAudioType1(getData).then((res) => {
        console.log("===>fmIcon", res.data.data.data);
        if (res.data.code === 200) {
          this.fmIcon = res.data.data.data;
        }
      });
    },
    //获取Playground
    getPlaygroundTypeUrl() {
      var that = this;
      var getData = {};
      var condition = {};
      let a = sessionStorage.getItem("userInfo");
      if (a == null) {
        condition.promptCode = "rz";
      } else {
        let promptCode = JSON.parse(
          sessionStorage.getItem("userInfo")
        ).promptCode;
        if (promptCode == "kj" || promptCode == "KJ") {
          condition.promptCode = "kj";
        } else if (promptCode == "rz" || promptCode == "RZ") {
          condition.promptCode = "rz";
        } else {
          return;
        }
      }
      getData.condition = condition;
      getData.pageSize = 5;
      getData.currPage = 1;
      // console.log("方法传入参数getData", getData);
      this.$api.home.getPlaygroundType1(getData).then((res) => {
        // console.log("方法getPlaygroundTypeUrl接口调用", res);
        if (res.data.code === 200) {
          this.playgroundIcon = res.data.data.data;
        }
      });
    },
    //获取教学大纲图片
    getImageUrl() {
      var that = this;
      var getData = {};
      var condition = {};
      let a = sessionStorage.getItem("userInfo");
      if (a == null) {
        condition.promptCode = "rz";
      } else {
        let promptCode = JSON.parse(
          sessionStorage.getItem("userInfo")
        ).promptCode;
        if (promptCode == "kj" || promptCode == "KJ") {
          condition.promptCode = "kj";
        } else if (promptCode == "rz" || promptCode == "RZ") {
          condition.promptCode = "rz";
        } else {
          return;
        }
      }
      getData.condition = condition;
      getData.pageSize = 5;
      getData.currPage = 1;
      this.$api.home.getPublicList(getData).then((res) => {
        if (res.data.code === 200) {
          this.publicIcon = res.data.data.data;
        }
      });
    },
    //获取活动照片
    getActivityUrl() {
      var that = this;
      this.$api.home.getActivityList({}).then((res) => {
        if (res.data.code === 200) {
          this.activityList = res.data.data.data;
          this.activityList = res.data.data.data.slice(0, 5);
        }
      });
    },

    // 教师园地
    goPublicIcon() {
      this.$router.push({
        path: "/teachClassification",
        query: {
          index: 0,
        },
      });
    }, // 教师园地
    goPublicIconSon(index) {
      this.$router.push({
        path: "/teachClassification",
        query: {
          index: index,
        },
      });
    }, // 前往节日活动
    goHoliday(index) {
      this.$router.push({
        path: "/holiday",
      });
    },

    // 前往节日活动详情
    goHolidayDetail(index) {
      this.$router.push({
        path: "/holidayDetail",
        query: {
          activityCode: this.activityList[index].activityCode,
        },
      });
    },

    //前往fm
    goFm() {
      this.$router.push({
        path: "/fm",
        query: {
          index: 0,
        },
      });
    },

    gokidsky() {
      this.$router.push({
        path: "/kidsky",
      });
    },
    //前往fm
    goFmSon(index) {
      this.$router.push({
        path: "/fm",
        query: {
          index: index,
        },
      });
    },
    //前往儿童乐园
    goPlaygroundSon(index) {
      this.$router.push({
        path: "/kidsky",
        query: {
          index: index,
        },
      });
    },
    //前往cec
    goCec(index) {
      if (index == 1 || index == 2) {
        this.$router.push({
          path: "/cec",
          query: {
            type: index,
          },
        });
      } else if (index == 0) {
        this.$router.push({
          path: "/cecDetail",
        });
      } else if (index == 3) {
        window.open(this.url, "_blank");
      } else {
        this.$router.push({
          path: "/cecTest",
        });
      }
    },

    getBannerList() {
      //轮播
      this.$api.home.getBannerList().then((res) => {
        // console.log("轮播图", res);
        if (res.data.code === 200) {
          this.swiperList = res.data.data.data;
        }
      });
    },
    //跳转至轮播图地址
    jumpDetail(item) {
      console.log("item.pathUrl", item);

      // this.$router.push({
      //   path: '/bannerUrlVideo',
      //   query: {
      //     featuresCode: item.featuresCode,

      //   },
      // });
    },
  },

  created() {
    this.$store.commit(CHANGE_NAVINDEX, "0");
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.getBannerList();
    this.getImageUrl();
    this.getActivityUrl();
    this.getAudioTypeUrl();
    this.getPlaygroundTypeUrl();
  },
};
</script>

<style lang="less" scoped>
.swiper {
  margin-top: 48px;
}
.mb46 {
  margin-bottom: 46px;
}
.homeTitle {
  padding: 10px;
  background-color: #fab300;
  margin-top: 23px;
  margin-bottom: 15px;
  color: white;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  text-align: left;
  .title {
    font-size: 20px;
    font-weight: bold;
  }
}
.navBox {
  display: flex;
  // padding: 0 51px;
  justify-content: flex-start;
  background-color: #f2f1f1;
  align-items: center;
  flex-flow: wrap;
  .nav_item {
    display: flex;
    width: 20%;
    margin: 21px 0;
    flex-direction: column;
    align-items: center;
    .navItem_img {
      height: 60px;
      width: 60px;
      border-radius: 50%;
      overflow: hidden;
    }

    .navItem_text {
      margin-top: 18px;
      font-size: 17px;
      font-weight: 600;
      color: #000000ff;
    }
  }

  .nav_item_festival {
    display: flex;
    width: 20%;
    margin: 21px 0;
    flex-direction: column;
    align-items: center;
    .navItem_img_festival {
      height: 113px;
      width: 113px;
      margin-top: 20px;
      border-radius: 6px;
      // overflow: hidden;
    }

    .navItem_text__festival {
      margin-top: 18px;
      font-size: 17px;
      color: #000000ff;
    }

    .navItem_text__festival2 {
      margin-top: 8px;
      font-size: 14px;
      color: #000000ff;
    }
  }
}
.topTitle {
  margin: 60px 0 32px;
  font-size: 24px;
}
.hoverBox1:hover {
  transform: scale(1.05);
  transition: all 0.1s linear;
  box-shadow: 0 0 7px 1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.titlebg {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 100px;
  background-image: url(../../assets/img/home/titlebg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: 30px;
}
.centerTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  padding: 20px;
  background-color: #fab300;
  margin-top: 80px;
  color: white;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
</style>
